"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setOpenQueryParam = exports.removeOpenQueryParam = exports.getValidOpenQueryParam = exports.getOpenQueryParam = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _constants = require("../constants");
const getOpenQueryParam = () => {
  const url = (0, _presentationUtils.getCurrentUrl)();
  return url.searchParams.get(_constants.OPEN_QUERY_PARAM);
};
exports.getOpenQueryParam = getOpenQueryParam;
const getValidOpenQueryParam = () => {
  const queryParam = getOpenQueryParam();
  return queryParam === _constants.OPEN_QUERY_PARAM_ONCE || queryParam === _constants.OPEN_QUERY_PARAM_ALWAYS ? queryParam : undefined;
};
exports.getValidOpenQueryParam = getValidOpenQueryParam;
const removeOpenQueryParam = () => {
  if (getOpenQueryParam()) {
    const url = (0, _presentationUtils.getCurrentUrl)();
    url.searchParams.delete(_constants.OPEN_QUERY_PARAM);
    (0, _presentationUtils.replaceCurrentUrl)(url);
  }
};
exports.removeOpenQueryParam = removeOpenQueryParam;
const setOpenQueryParam = () => {
  const url = (0, _presentationUtils.getCurrentUrl)();
  url.searchParams.set(_constants.OPEN_QUERY_PARAM, _constants.OPEN_QUERY_PARAM_ONCE);
  if (url.searchParams.get(_constants.OPEN_QUERY_PARAM) !== getOpenQueryParam()) {
    (0, _presentationUtils.replaceCurrentUrl)(url);
  }
};
exports.setOpenQueryParam = setOpenQueryParam;